export enum SortType {
  NOT_SELECTED = "not_selected",
  PRICE_ASC = "cheap",
  PRICE_DESC = "expensive",
  NEW = "new",
}

export interface FilterOptions {
  search?: string | null;
  minPrice?: number | null;
  maxPrice?: number | null;
  sort?: SortType | null;
  filter?: Map<string, string[]> | null;
  range?: Map<string, string[]> | null;
}

const FILTER_ITEM_REGEX = /(\d+-\d+)/g;

class FilterUrlTransformer {
  parseEnumSort(urlValue: string): SortType | null {
    const key = Object.entries(SortType).find(
      ([key, value]) => value === urlValue
    );
    if (!key) {
      return null;
    }

    return SortType[key[0] as keyof typeof SortType];
  }

  parseNumber(urlValue: string): number | null {
    if (urlValue && !isNaN(Number(urlValue))) {
      return Number(urlValue);
    }

    return null;
  }

  parseFilters(urlFilters: string): Map<string, string[]> {
    const filters = new Map<string, string[]>();
    if (urlFilters.length) {
      const filtersArr = urlFilters.split(";");

      filtersArr.forEach((part) => {
        const attrId = part.split("-", 1).toString();
        const values = part.split("-").slice(1).join("-");
        let valueIds: string[] = [];
        if (values?.length) {
          valueIds = values.split("||");
        }

        if (!filters.has(attrId)) {
          filters.set(attrId, []);
        }

        valueIds.forEach((valueId) => {
          filters.get(attrId)?.push(valueId);
        });
      });

      return filters;
    }
    return filters;
  }

  transformAttrMapToUrl(attributes: Map<string, string[]>): string {
    const attrPairs: string[] = [];
    for (const [attrId, valueIds] of attributes) {
      attrPairs.push(`${attrId}-${valueIds.join('||')}`);
    }

    return attrPairs.join(";");
  }

  transformArrayToUrl(values: Array<any>) {
    return values.join("||");
  }
}

export default new FilterUrlTransformer();
